import React from 'react'
import { useTranslation } from '@/i18n'

const AccountInfoPage: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <div className="placeholder-card">
        <h3 className="text-xl font-bold mb-2">{t('accountInfo.title')}</h3>
        <p className="text-gray-500">{t('accountInfo.underDevelopment')}</p>
      </div>
    </div>
  )
}

export default AccountInfoPage